/**
 * ProductTabs custom element
 * Manages the tabbed interface on the product page.
 * Tabs: Awards, Description, Specs, Credits, Reviews
 */
class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.selectTab(i));
      tab.addEventListener('keydown', (e) => this.handleKeydown(e, i));
    });

    // Activate the default tab (Description = index 1 by default)
    const defaultIndex = parseInt(this.dataset.defaultTab || '1', 10);
    this.selectTab(defaultIndex);
  }

  selectTab(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.panels.forEach((panel, i) => {
      panel.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
    });

    // Re-initialise Loox if the newly active panel contains a reviews widget.
    // Loox initialises on DOMContentLoaded; panels are display:none at that
    // point so the widget may be skipped. Calling init() here ensures it
    // renders once the panel becomes visible.
    const activePanel = this.panels[index];
    if (activePanel && activePanel.querySelector('#looxReviews')) {
      if (typeof window.Loox !== 'undefined') {
        window.Loox.init();
      }
    }
  }

  handleKeydown(e, index) {
    const count = this.tabs.length;
    let next = index;

    switch (e.key) {
      case 'ArrowRight':
        next = (index + 1) % count;
        break;
      case 'ArrowLeft':
        next = (index - 1 + count) % count;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = count - 1;
        break;
      default:
        return;
    }

    e.preventDefault();
    this.selectTab(next);
    this.tabs[next].focus();
  }
}

customElements.define('product-tabs', ProductTabs);
